import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { ExtendedTarificationSchema } from './tarification/TarificationFormData';
import { MarginRateSchema } from '../common/margin-rate.schema';

export const VehicleWithChauffeurSchema = ExtendedTarificationSchema.extend({
  name: z.string({ message: 'Le nom est requis' }),
  supplier: isValidSelectorString('Le fournisseur est requis'),
  currency: isValidSelectorString('La devise est requise'),
  country: isValidSelectorString('Le pays est requis'),
  marginRate: MarginRateSchema.optional(),
  model: z.string().optional(),
  shortDescription: z.string().optional(),
  longDescription: z.string().optional(),
  maxCapacity: z.coerce.number().int().min(0).optional(),
  images: z.array(z.union([z.instanceof(Blob), z.string()])),
});

export type VehicleWithChauffeurFormData = z.infer<
  typeof VehicleWithChauffeurSchema
>;
